module.exports = __webpack_public_path__ + "img/icon-retirement-white.bc18ff82.svg";